import { render, staticRenderFns } from "./GenerateBtn.vue?vue&type=template&id=25ed1041&scoped=true&"
import script from "./GenerateBtn.vue?vue&type=script&lang=js&"
export * from "./GenerateBtn.vue?vue&type=script&lang=js&"
import style0 from "./GenerateBtn.vue?vue&type=style&index=0&id=25ed1041&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ed1041",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
